import { faCheck, faFilePdf } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { BigButton } from "../report/sections/util";
import { WhitePage } from "./util";

const Col = ({
  title,
  desc,
  price,
  features,
  icon,
  subscription = false,
  selected = false,
  example = "",
}) => (
  <div className="mb-6 lg:mb-0">
    <div
      className={`block rounded-lg shadow-lg bg-white pt-6 h-full${
        selected ? " border border-blue-600" : " border-t border-light-gray"
      }`}
    >
      <div className="text-center flex items-center justify-center">
        <div className="bg-sidebar-menu-icon group-hover:bg-sidebar-menu-focus rounded-xl w-14 h-14 flex items-center justify-center">
          {icon}
        </div>
      </div>

      <div className="p-6 border-gray-300">
        <h3 className="text-xl font-semibold">{title}</h3>
        <p className="text-sm mb-4">{desc}</p>

        <h3 className="text-xl font-semibold">v.a. €{price}</h3>
        <p className="text-sm mb-4 text-gray-500">{subscription ? "Per maand" : "Per perceel"}</p>

        <div className="text-center">
          <button className="underline">Wat is het?</button>
        </div>
        <BigButton className="mt-4">
          {subscription ? "Kies een abonnement" : "Selecteer perceel"}
        </BigButton>
        {example ? (
          <BigButton className="mt-2 bg-white border border-gray">Voorbeeld</BigButton>
        ) : (
          <div className="m-16"> </div>
        )}
      </div>
      <div className="p-6 pt-0">
        <ol className="list-inside">
          {features.map((s, index) => (
            <li key={index} className="mb-4 flex items-center">
              <FontAwesomeIcon icon={faCheck} className="w-4 h-4 text-sidebar-menu-active mr-2" />
              {s}
            </li>
          ))}
        </ol>
      </div>
    </div>
  </div>
);

export const Plus = () => (
  <WhitePage>
    <h2 className="text-3xl font-bold">
      <span>Bodematlas</span>
      <span className="bg-light-green rounded-full text-2xs text-green px-2 h-4 relative -right-4 -top-2 z-10">
        Plus
      </span>
    </h2>
    <p className="mb-10 text-gray-500">Gebruik Bodematlas professioneel</p>

    <div className="grid lg:grid-cols-4 gap-6 xl:gap-x-12">
      <Col
        title="Abonnement"
        desc="Onbeperkt basisdata"
        price="50"
        icon={<FontAwesomeIcon icon={faCheck} className="w-6 h-6 text-sidebar-menu-active" />}
        subscription={true}
        features={["Alle percelen bekijken", "Alle basisdata van elk perceel"]}
      />
      <Col
        title="Factsheets"
        desc="Downloads"
        price="10"
        icon={<FontAwesomeIcon icon={faFilePdf} className="w-6 h-6 text-sidebar-menu-active" />}
        example="abc"
        features={["Download een enkel factsheet", "Handig om mee te nemen"]}
      ></Col>
    </div>
  </WhitePage>
);
